import { getLanguage, getLanguageIso2 } from '../modules/i18n';
import type { JbLanguageAlert } from '@bjb/bjb-web-components/dist/components/jb-language-alert/jb-language-alert';

const languageIso2Promise = getLanguageIso2();
const languageIdPromise = getLanguage();

window.addEventListener('DOMContentLoaded', async () => {
  const el = document.querySelector<JbLanguageAlert>('jb-language-alert');
  if (!el) {
    return;
  }

  const [languageIso2, languageId] = await Promise.all([languageIso2Promise, languageIdPromise]);
  const pageLanguage = document.documentElement.lang;

  if (!languageIso2 || !pageLanguage || pageLanguage === languageIso2) {
    return;
  }

  let texts: Record<string, string> = {};
  try {
    texts = JSON.parse(el.dataset.texts ?? '{}');
  } catch {
    return;
  }

  const text = texts[`language${languageId}`] ?? texts.language0 ?? '';
  if (text) {
    el.text = text;
  }
});
